module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrainshowers-d6c8d496397ae849226c2895ab3653c1.svg";